import { useEffect } from 'react';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Divider } from '@mui/material';

import UnitShiftAssignModal from '@/components/Modals/UnitShiftListModal/components/UnitShiftAssignModal';
import { withLoader, WithLoaderProps } from '@/hocs';
import { useCFSContext } from '@/hooks';
import { useUserStore } from '@/store';

import { RadioClicksList, RadioClicksPopover } from './components';
import {
  useRadioClicksData,
  useRadioClicksScroll,
  useUnitShiftAssignment,
} from './hooks';
import { RadioClicksButton, RadioClicksRoot } from './styles';

const RadioClicks = ({ showLoader, hideLoader }: WithLoaderProps) => {
  const { account } = useUserStore();
  const { cfs } = useCFSContext();
  const isEnabledRadioClicksModule =
    account?.settings?.features?.isEnabledRadioClicksModule;

  // Custom hooks
  const { groupedData, isLoading, hasNewData, acknowledgeNewData } =
    useRadioClicksData();
  const {
    containerRef,
    handleScrollLeft,
    handleScrollRight,
    canScrollLeft,
    canScrollRight,
    handleWheel,
    scrollToLatest,
  } = useRadioClicksScroll();
  const {
    selectedRadioClick,
    anchorEl,
    open,
    assignUnitShiftModal,
    handleClick,
    handleClose,
    handleAssignUnitShift,
    onCloseModal,
  } = useUnitShiftAssignment(showLoader, hideLoader);

  if (!isEnabledRadioClicksModule) {
    return null;
  }

  useEffect(() => {
    if (hasNewData) {
      scrollToLatest();
      acknowledgeNewData();
    }
  }, [hasNewData]);

  return (
    <RadioClicksRoot>
      {/* Navigation Buttons */}
      <RadioClicksButton onClick={handleScrollLeft} disabled={!canScrollLeft}>
        <ArrowBackIosIcon sx={{ height: '12px' }} />
      </RadioClicksButton>

      {/* Main Content */}
      <RadioClicksList
        containerRef={containerRef}
        groupedData={groupedData}
        handleClick={handleClick}
        isLoading={isLoading}
        handleWheel={handleWheel}
      />

      <Divider orientation="vertical" flexItem />
      <RadioClicksButton onClick={handleScrollRight} disabled={!canScrollRight}>
        <ArrowForwardIosIcon sx={{ height: '12px' }} />
      </RadioClicksButton>

      {/* Popover */}
      {selectedRadioClick?.radioId && (
        <RadioClicksPopover
          open={open}
          anchorEl={anchorEl}
          handleClose={handleClose}
          selectedRadioClick={selectedRadioClick}
          handleAssignUnitShift={handleAssignUnitShift}
          cfs={cfs}
        />
      )}

      {/* Unit Shift Assignment Modal */}
      <UnitShiftAssignModal
        onClose={onCloseModal}
        cfsId={cfs ? cfs?._id : undefined}
        {...assignUnitShiftModal}
      />
    </RadioClicksRoot>
  );
};

export default withLoader(RadioClicks);
